/**
 * Capitalize placeholder values stored in lowercase (e.g. "no current position").
 */
export const formatCandidateDisplayValue = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed !== trimmed.toLowerCase()) {
    return value;
  }

  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};
